










































import {Component, Prop, Vue} from "vue-property-decorator";
import JsonViewer from 'vue-json-viewer'
import {Getter} from 'vuex-class';
import ImageComponent from "@/valchrom/views/mathservice/dataset/overview/ImageComponent.vue";

@Component({
    components: {
        JsonViewer,
        VisualComponent: () => import("@/valchrom/views/mathservice/dataset/overview/VisualComponent.vue"),
        ImageComponent
    }
})
export default class ChromatogramComponent extends Vue {
    @Prop() model: any;
    @Getter overview_simplify !: boolean;

    formatExtraValue(extra:any){
        let unitsString = "";
        if(extra.unit) {
            unitsString = " " + extra.unit
        }
        return extra.value + unitsString
    }
}
